import { meetingStore } from '@/features/meetings/meetings.state';
import type {
  TranscriptionInputDeviceConfig,
  TranscriptionInputDeviceStorage,
} from '@/features/transcription-input-device';
import { settingsStore } from '@/stores/settings.store';

const meetingPreferenceStorage: TranscriptionInputDeviceStorage = {
  read: () => settingsStore.preferredMeetingTranscriptionInputDevice,
  write: (selection) =>
    settingsStore.setPreferredMeetingTranscriptionInputDevice(selection),
};

/**
 * The pin itself, as edited outside an active meeting (settings, idle meeting
 * headers). Shows what is saved, and only reaches the native side when a
 * meeting is already listening and would otherwise keep the old device.
 */
export const MEETING_PREFERENCE_INPUT_DEVICE_CONFIG: TranscriptionInputDeviceConfig =
  {
    cacheKey: 'meeting-preference',
    storage: meetingPreferenceStorage,
    displayMode: 'saved_preference',
    shouldApplyImmediately: () => meetingStore.recording.status === 'recording',
  };

/**
 * The device a running meeting is capturing from. Shows the live selection so a
 * pinned-but-unplugged mic reads as the fallback actually in use, and always
 * pushes a change to the native side.
 */
export const ACTIVE_MEETING_INPUT_DEVICE_CONFIG: TranscriptionInputDeviceConfig =
  {
    cacheKey: 'active-meeting',
    storage: meetingPreferenceStorage,
    displayMode: 'live_effective',
    shouldApplyImmediately: () => true,
  };
